import esMxCommons from '@casanova/casanova-common/lib/utils/i18n/es-MX-commons.json';
import localEsMx from './es-MX.json';

const esMx = {
  ...esMxCommons,
  ...localEsMx,
};

const CODES = {
  MX: 'es-MX',
};

const languages = {
  [CODES.MX]: esMx,
};

const getLocaleCode = () => CODES.MX;

const replaceAllVars = (message, elements) => {
  elements.forEach((element, index) => {
    // eslint-disable-next-line no-param-reassign
    message = message.replace(`%${index + 1}`, element);
  });
  return message;
};

const I18n = (key, replaces = []) => {
  const locale = languages[getLocaleCode()];
  if (replaces.length === 0) return locale[key];
  return replaceAllVars(locale[key], replaces);
};

export default I18n;
